exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".default-shipping[data-v-53b314da] {\n  margin-bottom: 2em;\n}\n.submit-btn[data-v-53b314da] {\n  margin-top: 2em;\n}\n.cancel-btn[data-v-53b314da] {\n  margin-top: 0.6em;\n}\n.show-address-btn[data-v-53b314da] {\n  padding: 0;\n}\n", ""]);

// exports
